import { formatDate } from "@/utils";
import classNames from "classnames";
import { Key } from "react";

export default function Item5({ arr = [] }: any) {
  const navigate = useNavigate();
  const handleNewsDetail = (id: any) => {
    navigate(`/news/detail?id=${id}`, {
      replace: false,
    });
  };

  return (
    <div>
      {arr.map((it: any, idx: Key | null | undefined) => (
        <div key={idx}>
          {idx === 0 && (
            <div className="px-16" onClick={() => handleNewsDetail(it.id)}>
              <div className="w-full h-192 rounded-10 relative mb-10">
                <img className="w-full h-192 rounded-10 " src={it.image} alt="" />
                <div className="w-full h-81 rounded-[0_0_10px_10px] bg-[linear-gradient(180deg,var(--app-bg-42)_0%,var(--app-bg-43)_100%)] absolute left-0 bottom-0">
                  <div className="text-ellipsis-2 absolute top-19 left-16 w-296px font-500 text-14 color-[var(--app-text-04)]">
                    {it.title}
                  </div>
                  <div className="absolute top-57 left-16 font-400 text-12 color-[var(--app-text-02)]">
                    <i>{formatDate(it.addtime)}</i>
                    <i className="font-900"> · </i>
                    <i>{it.media}</i>
                  </div>
                </div>
              </div>
            </div>
          )}
          {idx != 0 && (
            <div>
              <Item1 it={it} formatDate={formatDate} handleNewsDetail={handleNewsDetail} />
              <div
                className={classNames([
                  "b-b-1 b-b-solid mb-10",
                  idx != arr.length - 1 ? "b-b-[var(--app-border-02)]" : "b-b-transparent",
                ])}
              ></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
